export const rubricRefinementSelectors = {
    refinementItems: state => state.rubricRefinement.refinementItems,
    refinementItemById: (state, id) => state.rubricRefinement.refinementItems.find(item => item.id === id),
    lastRefinementItem: state => {
        const items = state.rubricRefinement.refinementItems
        return items.length > 0 ? items[items.length - 1] : null
    },
    lastSubmissionItem: state => {
        const submissionItems = state.rubricRefinement.refinementItems.filter(item => item.type === 'Submission')
        return submissionItems?.at(-1)
    },
    refinementProcess: state => state.rubricRefinement.refinementProcess,
    refinementProgress: state => state.rubricRefinement.refinementProcess?.progress,
    hoveredCategoryId: state => state.rubricRefinement.hoveredCategoryId,
    hoveredRefinementItemId: state => state.rubricRefinement.hoveredRefinementItemId,
    hoveredRefinementItem: state => {
        const hoveredId = state.rubricRefinement.hoveredRefinementItemId
        if (!hoveredId) return null
        return state.rubricRefinement.refinementItems.find(item => item.id === hoveredId)
    },
    // Returns the submission that should be displayed in the SubmissionCard
    // This will be the hovered refinement item if hovering, otherwise the last submission item
    displayedSubmissionItem: state => {
        const hoveredItem = rubricRefinementSelectors.hoveredRefinementItem(state)
        if (hoveredItem && hoveredItem.type === 'Submission') {
            return hoveredItem
        }
        return rubricRefinementSelectors.lastSubmissionItem(state)
    },
    hasStarted: state => state.rubricRefinement.hasStarted,
    hasApprovedSuggestions: state => {
        const { refinementItems } = state.rubricRefinement
        return refinementItems.some(item => 
            item.type === 'RubricSuggestion' && 
            item.diffReviewChoice === 'approved'
        )
    },
}
